(function () {
    'use strict';

    angular
        .module('app.home')
        .constant('ultimateScorecardResolver', {
            facilities: getFacilities
        });

    var extend = angular.extend;

    getFacilities.$inject = ['Score', 'user'];
    function getFacilities(Score, user) {
        var year = new Date().getFullYear();
        return Score.getUltimateScorecardFacilities({ individualId: user.id, year: year }, true).$promise.then(success);

        function success(data) {
            return extend(data, { year: year });
        }
    }
})();